import { Pipe, PipeTransform } from '@angular/core';
import { WhatsappGroup } from 'src/models/whatsappGroup';
import { WhatsappReferenceType } from 'src/models/whatsappGroupRequest';

@Pipe({
    name: 'filterByWhatsappGroupType',
    pure: false
})
export class FilterByWhatsappGroupType implements PipeTransform {
    transform(items: WhatsappGroup[], referenceType: WhatsappReferenceType): any {
        return referenceType ? items.filter(item => item.WhatappGroupTypeId === referenceType as number) : items;
    }
}
